import React from "react";
import {Alert, Button, Spin, Typography} from "antd";
import {Link} from "react-router-dom";
import ChartRenderer from "../components/ChartRender/ChartRenderer";
import Dashboard from "../components/Dashboard";
import DashboardItem from "../components/DashboardItem";
import PageHeader from "../components/PageHeader";
import {inject, observer} from "mobx-react";
import {PlusCircleOutlined} from '@ant-design/icons';

const deserializeItem = i => ({
  ...i,
  layout: JSON.parse(i.layout || "{\"x\":0,\"y\":0,\"w\":4,\"h\":8}") || {},
  vizState: JSON.parse(i.vizState)
});

const defaultLayout = i => ({
  x: i.layout.x || 0,
  y: i.layout.y || 0,
  w: i.layout.w || 4,
  h: i.layout.h || 8,
  minW: 4,
  minH: 8
});

export const DashboardPageSimple = observer(( { loading, error, data, isInEditorMode }) => {
  if (loading) {
    return <Spin  />;
  }

  if (error) {
    return (
      <Alert
        message="Ошибка при загрузке отчёта"
        description={error.toString()}
        type="error"
      />
    );
  }

  const dashboardItem = item => (
    <div key={item.id} data-grid={defaultLayout(item)}>
      <DashboardItem key={item.id} itemId={item.id} title={item.name} item={item} ddinject={""}>
        <ChartRenderer vizState={item.vizState} />
      </DashboardItem>
    </div>
  );

  const Empty = () => (
    <div
      style={{
        textAlign: "center",
        padding: 12
      }}
    >
      <h2>На этом дэшборде нет элементов</h2>
      <Link to={`/explore/${data.id}`}>
        <Button type="primary" size="large" >
            <PlusCircleOutlined />
          Добавить
        </Button>
      </Link>
    </div>
  );

  return !data || data.dashboardItems.length ? (
    <div>
      <PageHeader
        title={<Typography.Title level={4}>Дэшборд</Typography.Title>}
        button={<Link to={`/explore/${data.id}`}>
          <Button type="primary">
              Добавить
          </Button>
        </Link>}
      />
      <Dashboard dashboard={data} dashboardItems={data && data.dashboardItems} ddinject={""}>
        {
            data && data.dashboardItems.map(deserializeItem).map(dashboardItem)}
      </Dashboard>
    </div>
  ) : <Empty />;
});

const DashboardPage = inject('dashboard')(observer(({ dashboard, location, match }) => {
    const wd = match.params.wd
    const isInEditorMode = match.params.editor
    console.log('loc', location)
    console.log('mathc', match)
    dashboard.insureServer(wd)
    const cnt = dashboard.items ? dashboard.items.length : 0;
    return (
        <DashboardPageSimple data={dashboard} isInEditorMode={isInEditorMode}>{cnt}</DashboardPageSimple>
    )
}))

export default DashboardPage;
